import { ProductsApiClient } from '@fourthwall/services/dist/ProductsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useProductBySlugQuery = createQueryHook(ProductsApiClient.getProductBySlug, {
  queryKey: ['productBySlug'],
})
